import Image from 'next/image';
import ReactDOM from 'react-dom';

export interface LoadingBoxProps {
  className?: string;
  domParent?: HTMLElement | null;
}

const LoadingBox = (props: LoadingBoxProps) => {
  const { className = '', domParent } = props;

  const loadingComponent = (
    <div
      className={`absolute left-0 top-0 z-10 flex size-full items-center justify-center bg-white/[.60] ${className}`}
    >
      <div className="flex aspect-square h-4/5 max-h-[56px] w-auto items-center justify-center rounded-lg bg-white drop-shadow-lg">
        <Image src="/Loading.gif" alt="loading" width={56} height={56} />
      </div>
    </div>
  );

  if (domParent) {
    return ReactDOM.createPortal(loadingComponent, domParent);
  }
  return loadingComponent;
};

export default LoadingBox;
